var dist = require('./dist/')

module.exports = dist
